import React from 'react';
import { companyData } from '../data/data';

export default function Partner() {
  return (
    <div className="flex justify-center items-center">
      {companyData.map((item: any, index: number) => {
        return (
          <div className="mx-auto" key={index}>
            <img src={item} className="h-48" alt="" />
          </div>
        );
      })}
    </div>
  );
}
